import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import { getAppIsLoadingSelector, getAppOrderCompleteSelector } from '../../redux/reducers/app/appSelector';
import { getConfirmationOrderSelector } from '../../redux/reducers/confirmation/orderConfirmationSelector';
import { getRouterLocationPathname } from '../../redux/reducers/router/routerSelector';
import shouldShowFullScreenSignUp from '../../utils/myjl/fullScreenSignUp';

const getShowFullScreenSignUpFlowSelector = createSelector(
  [(state: RootState) => state],
  (state: RootState) => shouldShowFullScreenSignUp(state),
);

const headerState = createSelector(
  [
    getAppIsLoadingSelector,
    getConfirmationOrderSelector,
    getAppOrderCompleteSelector,
    getRouterLocationPathname,
    getShowFullScreenSignUpFlowSelector,
  ],
  (isLoading, order, orderComplete, pathname, showFullScreenSignUpFlow) => ({
    isLoading,
    order,
    orderComplete,
    pathname,
    showFullScreenSignUpFlow,
  }),
);

export default headerState;
